import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import React, {useState} from 'react';
import {Controller, FieldValues, useFormContext} from 'react-hook-form';

import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import {PasswordInputProps} from './types';

const {passwordPlaceholder} = translations['pt-br'].publicFlow.formPlaceholders;

export function PasswordInput<T extends FieldValues>({
	name,
	inputRef,
	autoComplete,
	hideHelperText,
	label,
	...rest
}: PasswordInputProps<T>) {
	const [showPassword, setShowPassword] = useState(false);
	const {resetField, control} = useFormContext();

	function handleToggleShowPassword() {
		setShowPassword(show => !show);
	}
	function handleClear() {
		resetField(name);
	}

	return (
		<Controller
			name={name}
			control={control}
			render={({field, fieldState: {invalid, isDirty, error}}) => {
				const showHelperText = isDirty && !hideHelperText;
				return (
					<TextField
						{...rest}
						{...field}
						autoComplete={autoComplete}
						id={field.name}
						inputRef={inputRef}
						type={showPassword ? 'text' : 'password'}
						error={isDirty && invalid}
						helperText={showHelperText ? error?.message : undefined}
						label={label || passwordPlaceholder}
						slotProps={{
							...rest.slotProps,
							input: {
								...rest.slotProps?.input,
								endAdornment: isDirty ? (
									<InputAdornment position="end">
										<IconButton
											aria-label="toggle password visibility"
											onClick={handleClear}
											edge="end">
											<Icon name="close-filled" />
										</IconButton>

										<Divider
											sx={{height: 24, p: '6px', m: '2px'}}
											orientation="vertical"
										/>

										<IconButton
											aria-label="toggle password visibility"
											onClick={handleToggleShowPassword}
											edge="end">
											<Icon
												name={
													showPassword
														? 'visibility-filled'
														: 'visibility-off-filled'
												}
											/>
										</IconButton>
									</InputAdornment>
								) : null,
							},
						}}
					/>
				);
			}}
		/>
	);
}
